import { Box } from "@mui/material";
import { Roadview, RoadviewMarker } from "react-kakao-maps-sdk";
import { useState } from "react";

interface Props {
  position: {
    lat: number;
    lng: number;
  };
  label: string;
  initialRadius?: number;
  maxRadius?: number;
  radiusIncrement?: number;
}

export default function KakaoRoadview({
  position,
  label,
  initialRadius = 50,
  maxRadius = 500,
  radiusIncrement = 50,
}: Props) {
  const [radius, setRadius] = useState(initialRadius);
  const [hasRoadview, setHasRoadview] = useState(true);

  const handleRoadviewError = () => {
    if (radius < maxRadius) {
      // Increase radius and try again
      setRadius(prevRadius => prevRadius + radiusIncrement);
    } else {
      // Max radius reached, no roadview available
      setHasRoadview(false);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        boxShadow:
          " rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
        borderRadius: "8px",
        position: "absolute",
        top: "-100px",
        right: "48px",
        width: "300px",
        height: "230px",
        padding: "8px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {hasRoadview ? (
          <Roadview
            position={{ ...position, radius }}
            style={{
              width: "100%",
              height: "100%",
            }}
            onErrorGetNearestPanoId={handleRoadviewError}
          >
            <RoadviewMarker
              position={position}
              onCreate={marker => {
                const roadview = marker.getMap() as kakao.maps.Roadview;

                // viewpoint(화면좌표)값을 추출할 수 있는 projection 객체를 가져옵니다.
                const projection = roadview.getProjection();

                // 마커의 position과 altitude값을 통해 viewpoint값(화면좌표)를 추출합니다.
                const viewpoint = projection.viewpointFromCoords(
                  marker.getPosition(),
                  marker.getAltitude()
                );

                viewpoint.zoom = -3;

                // 로드뷰에 뷰포인트를 설정합니다.
                roadview.setViewpoint(viewpoint);
                roadview.relayout();
              }}
            >
              {label && <div>{label}</div>}
            </RoadviewMarker>
          </Roadview>
        ) : (
          <Box
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#f5f5f5",
            }}
          >
            이 주소는 로드뷰를 제공하지 않습니다
          </Box>
        )}
      </Box>
      <Box
        sx={{
          fontSize: "12px",
          color: "#666",
          mt: "4px",
          textAlign: "center",
        }}
      >
        로드뷰는 주변 이미지를 표시하고 있어, 실제 위치와 조금 차이가 있을 수
        있어요
      </Box>
    </Box>
  );
}
